<template>
    <div class="inputContainer" :style="{width: width}">
        <input ref="input" :value="this.realValue" :class="{iconPadding: icon}" @input="inputChanged"
               :disabled="disabled" required>
        <span class="label">{{label}}</span>
        <div v-if="icon" class="iconContainer" :class="{leftBorder: iconBorder, pointer: this.$listeners.click}">
            <span class="icon" :class="[icon]"
                  @click="$emit('click')" :style="{color: iconColor, fontSize: iconSize}"></span>
        </div>

    </div>
</template>

<script>
    export default {
        name: "TemplateInput",
        data: function () {
            return {
                realValue: '',
                oldExt: ''
            };
        },
        computed: {},
        props: {
            disabled: Boolean,
            label: String,
            value: {
                type: String,
                default: ''
            },
            width: String,
            icon: String,
            iconColor: String,
            iconBorder: Boolean,
            iconSize: String,
            extensionText: {
                required: true,
                default: ''
            }
        },
        watch: {
            value: function () {
                let ext = this.extensionText ? this.extensionText : '';
                let oldReal = this.realValue ? this.realValue.replace(ext, '') : '';
                let oldExt = this.oldExt ? this.oldExt : '';
                oldReal = oldReal.replace(oldExt, '');
                this.realValue = oldReal + ext;

            },
            extensionText: function (old) {
                this.oldExt = old;
                let ext = this.extensionText ? this.extensionText : '';
                let oldReal = this.realValue ? this.realValue.replace(ext, '') : '';
                setTimeout(() => {
                    this.$refs.input.focus();
                    this.$refs.input.setSelectionRange(0, oldReal.length);
                }, 10);
            },
            realValue: function (newVal) {
                this.$emit('onRealValueChanged', newVal);
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            inputChanged(event) {
                if (!event.target.value.includes(this.extensionText)) {
                    this.$emit('input', this.realValue);
                    return;
                }
                this.realValue = event.target.value.replace(this.extensionText, '') + this.extensionText;
                this.$emit('input', this.realValue);
            },
            init() {
                this.realValue = this.value.replace(this.extensionText, '') + this.extensionText;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .inputContainer {
        position: relative;
        width: 300px;
    }

    input {
        padding: 1.1em 0.5em 0.5em 0.5em;
        width: 100%;
        font-size: 15px;
        border: 1px solid #d0d4da;
    }

    input:disabled {
        background: transparent;
        border-color: transparent;
        border-bottom: 1px solid #ccc;
        color: black;
    }

    input:focus ~ .label, input:disabled ~ .label,
    input:not(:focus):valid ~ .label, input:disabled:not(:focus):valid ~ .label {
        top: 5px;
        bottom: 10px;
        left: 0.9em;
        font-size: 11px;
        opacity: 1;
    }

    .iconPadding {
        padding-right: 3em;
    }

    .label {
        position: absolute;
        left: 0.65em;
        top: 1.2em;
        font-size: 1em;
        color: #777;
        pointer-events: none;
        transition: 0.2s ease all;
        opacity: 0.5;
    }

    .leftBorder {
        border-left: 1px solid #a9a9a9;
    }

    .iconContainer {
        position: absolute;
        top: 0;
        right: 0;
        border-left: 1px solid #a9a9a9;
        width: 47px;
        height: 100%;
    }

    .icon {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        right: 0;
        font-size: 2.1em;
    }

    .icon:hover {
        color: $pink;
    }

    .icon:before {
        display: flex;
    }

    .pointer {
        cursor: pointer;
    }
</style>